export default __webpack_public_path__ + "static/media/ICONO_DATOS.d1fa0c96.svg";